var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.useFontFamilyClass,attrs:{"id":"app"}},[(!_vm.isMobile && !_vm.isTablet)?_c('div',{staticClass:"app-container-bg"},[_c('div',{staticClass:"bg",class:{
        'container-hover': _vm.containerHoverStatus === 'hover',
        'container-leave': _vm.containerHoverStatus === 'leave',
      }})]):_vm._e(),_c('div',{staticClass:"app-container"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }